import request from '@/utils/request'

export function getPage(data) {
  return request({
    url: '/epvVehicle/getPage',
    method: 'post',
    data
  })
}

export function getList(data) {
  return request({
    url: '/epvVehicle/getListPage',
    method: 'post',
    data
  })
}

export function saveData(data) {
  return request({
    url: '/epvVehicle/save',
    method: 'post',
    data
  })
}

export function editData(data) {
  return request({
    url: '/epvVehicle/edit',
    method: 'post',
    data
  })
}

export function deleteData(data) {
  return request({
    url: '/epvVehicle/delete',
    method: 'post',
    params: data

  })
}
export function getInfo(data) {
  return request({
    url: '/epvVehicle/getInfo',
    method: 'get',
    params: data
  })
}

export function exportData(data) {
  return request({
    url: '/epvVehicle/export',
    method: 'post',
    responseType: 'blob',
    data
  })
}

export function getVehicles(data) {
  return request({
    url: '/epvVehicle/getList',
    method: 'post',
    params: data
  })
}

export function getStatistics(data) {
  return request({
    url: '/epvVehicle/getStatistics',
    method: 'post',
    data
  })
}

export function getStatistics2(data) {
  return request({
    url: '/epvVehicle/getStatistics2',
    method: 'post',
    data
  })
}

export function getStatistics3(data) {
  return request({
    url: '/epvVehicle/getStatistics3',
    method: 'post',
    data
  })
}

export function getInformationTable(data) {
  return request({
    url: '/epvVehicle/getInformationTable',
    method: 'post',
    data
  })
}

export function getInformationTable2(data) {
  return request({
    url: '/epvVehicle/getInformationTable2',
    method: 'post',
    data
  })
}

export function getTreeData(data) {
  return request({
    url: '/epvVehicle/getTreeData',
    method: 'post',
    params: data
  })
}

export function getAgainLoading(data) {
  return request({
    url: '/epvVehicle/getAgainLoading',
    method: 'post',
    params: data
  })
}

export function getLocationCurrent(data) {
  return request({
    url: '/epvVehicle/getLocationC',
    method: 'post',
    params: data
  })
}

export function getLocations(data) {
  return request({
    url: '/epvVehicle/getLocations',
    method: 'post',
    data
  })
}

export function getDeletedPage(data) {
  return request({
    url: '/epvVehicle/getDeletedPage',
    method: 'post',
    data
  })
}

export function updateStatus(data) {
  return request({
    url: '/epvVehicle/updateState',
    method: 'post',
    params: data
  })
}

export function deleteData2(data) {
  return request({
    url: '/epvVehicle/deleteData',
    method: 'post',
    params: data
  })
}

export function importData(data) {
  return request({
    url: '/epvVehicle/importData',
    method: 'post',
    data
  })
}